{
  "zh-CN": {
    "meta": {
      "description": "FleetYards.net, Your Database for all Information related to Ships from “Star Citizen“."
    },
    "model": {
      "focus": "定位",
      "classification": "分类",
      "size": "尺寸",
      "beam": "舰宽",
      "cargo": "货舱",
      "personalInventory": "飞船库存",
      "crew": "船员",
      "speed": "速度",
      "minCrew": "最少船员",
      "maxCrew": "最多船员",
      "scmSpeed": "SCM速度",
      "mainAcceleration": "加速",
      "retroAcceleration": "减速",
      "scmSpeedBoosted": "SCM增强速度",
      "reverseSpeedBoosted": "倒车增强速度",
      "maxSpeed": "最大速度",
      "scm": "SCM",
      "max": "最大",
      "groundMaxSpeed": "最大速度",
      "groundReverseSpeed": "倒车速度",
      "pitch": "俯仰",
      "pitchBoosted": "俯仰增强",
      "yaw": "偏航",
      "yawBoosted": "偏航增强",
      "roll": "翻滚",
      "rollBoosted": "翻滚增强",
      "price": "价格",
      "groundAcceleration": "加速度",
      "groundDecceleration": "减速度",
      "scmSpeedAcceleration": "零到SCM",
      "scmSpeedDecceleration": "SCM到零",
      "compare": {
        "groundMaxSpeed": "最大地面速度",
        "groundReverseSpeed": "倒车地面速度",
        "groundAcceleration": "地面加速度",
        "groundDecceleration": "地面减速度"
      },
      "quantumFuelTankSize": "量子燃料",
      "hydrogenFuelTankSize": "燃料",
      "pledgePrice": "承诺价格",
      "height": "高度",
      "length": "长度",
      "mass": "质量",
      "manufacturer": "制造商",
      "hardpoints": "挂载点",
      "weapons": "武器",
      "equipment": "装备",
      "variants": "变体",
      "productionStatus": "生产状态",
      "propulsion": "推进",
      "modular": "模块化",
      "soldAt": "出售于？",
      "rentalAt": "租赁于？",
      "poweredByUex": "数据由 UEX 提供",
      "lastUpdatedAt": "最后更新于？"
    },
    "component": {
      "manufacturer": "制造商",
      "size": "尺寸"
    },
    "availability": {
      "soldAt": "出售于",
      "boughtAt": "购买于"
    },
    "resources": {
      "models": "飞船",
      "hardpoints": "挂载点",
      "images": "图片"
    },
    "pagination": {
      "previous": "上一页",
      "next": "下一页",
      "gap": "&hellip;"
    }
  }
}
